import { render, staticRenderFns } from "./DataAccess.vue?vue&type=template&id=48f34412&"
import script from "./DataAccess.vue?vue&type=script&lang=ts&"
export * from "./DataAccess.vue?vue&type=script&lang=ts&"
import style0 from "./DataAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports